import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_13693_155874)">
    <circle cx="35" cy="33" r="25" fill="white"/>
    </g>
    <path d="M44.7025 29.0225C44.5575 29.135 41.9975 30.5775 41.9975 33.785C41.9975 37.495 45.255 38.8075 45.3525 38.84C45.3375 38.92 44.835 40.6375 43.635 42.3875C42.565 43.9275 41.4475 45.465 39.7475 45.465C38.0475 45.465 37.61 44.4775 35.6475 44.4775C33.735 44.4775 33.055 45.4975 31.5 45.4975C29.945 45.4975 28.86 44.0725 27.6125 42.3225C26.1675 40.2675 25 37.075 25 34.045C25 29.185 28.16 26.6075 31.27 26.6075C32.9225 26.6075 34.3 27.6925 35.3375 27.6925C36.325 27.6925 37.865 26.5425 39.745 26.5425C40.4575 26.5425 43.0175 26.6075 44.7025 29.0225ZM38.8525 24.485C39.63 23.5625 40.18 22.2825 40.18 21.0025C40.18 20.825 40.165 20.645 40.1325 20.5C38.8675 20.5475 37.3625 21.3425 36.455 22.395C35.7425 23.205 35.0775 24.485 35.0775 25.7825C35.0775 25.9775 35.11 26.1725 35.125 26.235C35.205 26.25 35.335 26.2675 35.465 26.2675C36.6 26.2675 38.0275 25.5075 38.8525 24.485Z" fill="black"/>
    <defs>
    <filter id="filter0_d_13693_155874" x="0" y="0" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="2"/>
    <feGaussianBlur stdDeviation="5"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13693_155874"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13693_155874" result="shape"/>
    </filter>
    </defs>
    </svg>
}

export default SvgComponent;
